/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { connectionsGet } from "../../funcs/connectionsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.GetConnectionConnectionsConnectionIdGetRequest$inboundSchema,
};

export const tool$connectionsGet: ToolDefinition<typeof args> = {
  name: "connections-get",
  description: `Get Connection

Get a connection.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await connectionsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
